import React from 'react'
import { connect } from 'react-redux'

import IconWithTextCard from './IconWithTextCard'

class UsersToday extends React.Component {
    render() {
        const dailyUsers = this.props.dailyUsers
        return <IconWithTextCard subTitle="Users today" title={dailyUsers} icon="user" cardColor="cyan" />
    }
}

const mapStateToProps = ({ dashboard }) => ({
    dailyUsers: dashboard.usersCounter.today
})

export default connect(
    mapStateToProps,
    null
)(UsersToday)
